import { render } from "./VirtualMachineBasics.vue?vue&type=template&id=306fca4d&scoped=true"
import script from "./VirtualMachineBasics.vue?vue&type=script&lang=js"
export * from "./VirtualMachineBasics.vue?vue&type=script&lang=js"

import "./VirtualMachineBasics.vue?vue&type=style&index=0&id=306fca4d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306fca4d"]])

export default __exports__